export default {
  crossChecksHelpers: {},
  compareHelpers: {},
  compareFeeHelpers: {}
}



// WEBPACK FOOTER //
// ./src/components/compare/store/state.js